import React, { useEffect,useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";

import frame1 from "../assets/frame1.png";
import frame2 from "../assets/frame2.png";
import frame3 from "../assets/frame3.png";
import frame4 from "../assets/frame4.png";
import service1 from "../assets/service1.png";
import service2 from "../assets/service2.png";
import service3 from "../assets/service3.png";

function About() {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  const products = [
    { title: "International brand frames", image: frame1 },
    { title: "Specialized kids’ frames", image: frame2 },
    { title: "Supportive accessories", image: frame3 },
    { title: "Sunglasses", image: frame4 },
    { title: "Specialized kids’ frames", image: frame2 },
    { title: "Supportive accessories", image: frame3 },
    { title: "Sunglasses", image: frame4 },
  ];
  useEffect(() => {
    AOS.init({
      duration: 1000,  // Animation duration in ms
      once: true,      // Only animate once per element
    });
  }, []);

  return (
    <div id="about" className="bg-white">
      {/* Section 1 */}
      <section className="py-10 px-4 sm:px-6 md:px-10 lg:px-20 text-center">
        <div data-aos="fade-right">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-manrope text-[#3471B8] mb-4">
            Welcome to Eye Care Optical
          </h2>
          <p className="text-[#343434] text-[16px] font-manrope font-medium max-w-4xl mx-auto leading-relaxed">
          When we say ‘we are your partner for clear vision’, we mean it! At Eye Care Optical, our motto is to go beyond
            simply selling eyewear—we desire to be your style partner in the journey of vision. We are your perfect partner,
            offering products that are stylish as well as reliable. Our curated collection includes high-quality prescription
            glasses, sunglasses, and contact lenses. The collection is made with top-tier materials, trendy and world-class
            design that ensures you look your best.
          </p>
        </div>

        <div data-aos="fade-right">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-manrope text-[#3471B8] mb-4 mt-10">
            The Eye Care range of products
          </h2>
          <p className="text-[#343434] text-[16px] font-manrope font-medium max-w-4xl mx-auto leading-relaxed">
          Thoughtful. Comfort. Style.<br />
            Every product we provide is thoughtfully selected that enhance your style along with your vision. From classic frames
            to high-trend style, our casket is full of what you prefer.
          </p>
        </div>
      </section>

      {/* Scrolling Product Cards */}
      <section className="relative ">
        {/* Left Arrow */}
        <button
          onClick={scrollLeft}
          className="absolute left-0 sm:left-2 top-1/2 transform -translate-y-1/2 z-10 bg-white hover:bg-blue-100 text-blue-800 rounded-full shadow p-2 transition duration-200"
        >
          <HiChevronLeft size={24} />
        </button>

        <div
  ref={scrollRef}
  className="flex gap-4 overflow-x-auto scroll-smooth scrollbar-hide pl-4 pr-0 md:py-16 md:pl-12 md:pr-0 py-4"
  style={{ WebkitOverflowScrolling: "touch" }}
>
  {products.map((item, index) => (
    <div
      key={index}
      className="w-[280px] sm:w-[240px] md:w-[280px] rounded-lg flex-shrink-0"
    >
      <div className="relative w-[280px] sm:w-[240px] md:w-[280px] h-[340px]">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover rounded-lg"
        />
        <div className="absolute inset-0 flex items-end justify-center p-5">
          <h3 className="text-[#343434] text-[15px] sm:text-[18px] font-bold text-center px-2 py-1 leading-snug rounded">
            {item.title}
          </h3>
        </div>
      </div>
    </div>
  ))}
</div>


        {/* Right Arrow */}
        <button
          onClick={scrollRight}
          className="absolute right-0 sm:right-2 top-1/2 transform -translate-y-1/2 z-10 bg-white hover:bg-blue-100 text-blue-800 rounded-full shadow p-2 transition duration-200"
        >
          <HiChevronRight size={24} />
        </button>
      </section>

      {/* Services Section */}
      <section className="bg-white py-8 px-4 md:py-16 md:px-12 text-center">
      <div data-aos="fade-up">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-manrope text-[#3471B8] mb-2">
          Exceptional Customer Service
          <br />
          <span className="text-[#3471B8]">– Our Pride</span>
        </h2>
        <p className="text-[#343434] font-manrope max-w-4xl mx-auto mb-10 text-[16px] font-medium">
        Recognized as one of the top eyewear providers in Rwanda, we ensure lasting relationships 
        by giving personalized care, expert advice, and providing the best after-sales service.
        </p>
        </div>

        <div data-aos="zoom-in" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {/* Card 1 */}
          <div className="bg-[#C4F1F9] rounded-xl shadow-md flex flex-col items-center overflow-hidden">
            <div className="w-full h-80 sm:h-96">
              <img
                src={service1}
                alt="After-Sales Service"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-[#343434] font-semibold font-manrope text-[20px] mb-4">
              After-Sales Service
            </h3>
          </div>

          {/* Card 2 */}
          <div className="bg-[#C4F1F9] rounded-xl shadow-md flex flex-col items-center overflow-hidden">
            <div className="w-full h-80 sm:h-96">
              <img
                src={service2}
                alt="Ultrasonic Cleaning"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-[#343434] font-semibold font-manrope text-[20px] mb-4">
              Ultrasonic Cleaning
            </h3>
          </div>

          {/* Card 3 */}
          <div className="bg-[#C4F1F9] rounded-xl shadow-md flex flex-col items-center overflow-hidden">
            <div className="w-full h-80 sm:h-96">
              <img
                src={service3}
                alt="Premium Cleaning Solutions"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-[#343434] font-semibold font-manrope text-[20px] mb-4">
              Premium Cleaning Solutions
            </h3>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
